import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import MediaList from '@/components/media/MediaList.vue';
import { Hero } from '@/models/hero.model';
import { ref, PropType, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroContentForm',
  props: {
  modelValue: { type: Object as PropType<Hero>, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const value = ref<Hero>({ ...props.modelValue });

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};

watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: value.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.name) = $event)),
            onChange: update,
            label: "Name",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(MediaList, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
            onChange: update
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})